<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">化学品出库登记</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="化学品名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="出库单号">
          <el-input v-model="formInline.record_number" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`所属场所`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择所属场所`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd(() => handleAddInit())">新增记录</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训化学品采购申请模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="name" label="化学品" min-width="150">
        </custom-table-column>
        <custom-table-column fixed prop="record_number" label="出库单号" width="150">
        </custom-table-column>
        <custom-table-column prop="quantity" label="出库总量" width="80">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="80">
        </custom-table-column>
        <custom-table-column prop="lyr" label="领用人" width="120">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="training_room" label="所属场所" width="180px">
        </custom-table-column>
        <custom-table-column prop="usage" label="用途" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="操作人" width="100px">
        </custom-table-column>
        <custom-table-column prop="created_at" label="操作时间" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <!-- <el-button @click="handleEditInit(scope.row)" type="text"
              size="small">编辑</el-button> -->
              <el-button @click="detailMethod(scope.row)" type="text"
              size="small">详情</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border v-if="rowObj">
        <el-descriptions-item>
          <template slot="label">化学品 </template> {{ rowObj.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">出库单号 </template> {{ rowObj.record_number }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">出库总量 </template> {{ rowObj.quantity }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单位 </template> {{ rowObj.unit }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属院系 </template> {{ rowObj.structure_1 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">专业 </template> {{ rowObj.structure_2 }}
        </el-descriptions-item>
        <el-descriptions-item :span="3">
          <template slot="label">用途 </template> {{ rowObj.usage }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">领用人 </template> {{ rowObj.lyr }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属{{ $store.state.themeTitle }}室 </template> {{ rowObj.training_room }}
        </el-descriptions-item>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">领用清单</p>
      <custom-table :data="rowObj.item_list" border style="width: 100%">
        <custom-table-column prop="item_code" label="化学品编号">
        </custom-table-column>
        <custom-table-column prop="quantity" label="出库量">
        </custom-table-column>
      </custom-table>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>

    <ChemicalUseChild ref="digChild" :digVisible='centerDialogVisible' @closeDig="closeDig">
    </ChemicalUseChild>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import ChemicalUseChild from './component/chemicalUseChild.vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        name: '',
        training_room: '',
        record_number:''
      },
      rowObj:'',
      chemicals: [],
      size: 'small',
      detailDialogVisible: false,
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        "structure_1": "",
        "structure_2": "",
        "product_id": "",
        "number": "",
        "quantity": '',
        "lyr": "",
        "training_room": "",
        "training_room_id": "",
        "usage": "",
        "date": "",
        "record_number": "",
        "apply_id": "",
      },
      kc: 0,
      rowObj: {},
      rules: {
        training_room_id: [{ required: true, message: '请选择', trigger: 'change' }],
        structure_2: [{ required: true, message: '请选择院系专业' }],
        product_id: [{ required: true, message: '请选择', trigger: 'change' }],
        date: [{ required: true, message: '请选择', trigger: 'change' }],
        quantity: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        usage: [{ required: true, message: '请输入', trigger: 'blur' }],
        lyr: [{ required: true, message: '请输入', trigger: 'blur' }],
        // training_room: [{ required: true, message: `请输入所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
      },
      action: '',
      downloadUrl: '',
      downloadName: '实训化学品采购申请模版.xlsx',
      btnTitle: '导入实训化学品采购申请数据',
      listArr: [],
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/device/purchase2/import`;
    this.downloadUrl = `api/device/purchase2/getTemplate`;
    this.$store.dispatch('getTarinMent');

    // this.$store.dispatch('getTermms');
  },
  computed: {
  },
  components: {
    ChemicalUseChild
  },
  mounted() { },
  methods: {
    async handleEditInit(row) {
      await this.$refs.digChild.handleEditNew(row)
      this.centerDialogVisible = true
    },
    detailMethod(row) {
        this.rowObj = row;
        this.detailDialogVisible = true;
    },
    async handleAddInit() {
      await this.$refs.digChild.hanldAdd()
      this.centerDialogVisible = true

    },
    closeDig(flag = false) {
      this.centerDialogVisible = false
      if (flag) {
        this.getList()
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/chemical/record/delete/${params.id}`, 'DELETE', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },

    handleQuery() {
      this.beforeQueryByKeyNew({ dep: 'structure_1' });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/record/query', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data.map(item => {
          item.product_id = item.product_id * 1
          return item
        });
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
